export default __webpack_public_path__ + "static/1339-b583ccfbfd804fd6c9993f8f943bdb64.gif";